import React, { useRef } from "react";
import { CSSTransition } from "react-transition-group";
import Portal from "../Portal";

interface SideModalProps {
  widthClass?: string;
  visible: boolean;
  closeOnOuterClick?: boolean;
  close?: () => void;
}

const SideModal: React.FC<SideModalProps> = ({
  visible,
  children,
  widthClass = "w-content",
  closeOnOuterClick,
  close,
}) => {
  const sideModalRef = useRef<HTMLElement>(null);
  return (
    <Portal>
      {visible && closeOnOuterClick && close && (
        <section
          className="fixed top-0 left-0 w-full h-screen"
          onClick={close}
        />
      )}
      <CSSTransition
        classNames="fade-left-small"
        timeout={300}
        in={visible}
        mountOnEnter
        unmountOnExit
        nodeRef={sideModalRef}
      >
        <section
          className="fixed w-screen h-full z-50 right-0 top-0 bg-clear-black-10 pointer-events-none flex justify-end text-text"
          ref={sideModalRef}
        >
          <section
            className={`h-full flex flex-col ${widthClass} shadow-left bg-light overflow-y-auto pointer-events-auto`}
          >
            {children}
          </section>
        </section>
      </CSSTransition>
    </Portal>
  );
};

export default SideModal;
